import styled from "styled-components";

export default styled.input`
    border: 0;
    border-radius: 5px;
    box-shadow: 0 0 4px 0 rgba(224, 224, 231, 0.6);
`;

